import { Link } from "../lib/route";
import {
  MessageCircle,
  ReceiptText,
  Clock,
  Home,
  CalendarCheck,
  Award,
  ArrowRight,
} from "lucide-react";
import { WHY_US, IMAGES, COPY, withElStyle } from "../lib/_data";

const ICONS = { MessageCircle, ReceiptText, Clock, Home, CalendarCheck, Award };

export default function WhyChooseUs() {
  const c = COPY.home.whyChooseUs || {};
  return (
    <section
      {...withElStyle("why-choose-us", { className: "bg-[#fffdf9] py-20 md:py-32" })}
      data-testid="why-choose-us"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <span className="text-xs tracking-[0.24em] uppercase font-bold text-[#c85a3c]" data-testid="why-choose-us-eyebrow">
            {c.eyebrow || "Why homeowners choose us"}
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-black text-[#2c2a29] leading-[1.05] mt-4" data-testid="why-choose-us-heading">
            {c.title || "The kind of local business your neighbor recommends."}
          </h2>
          <p className="mt-6 text-[#5c5855] leading-relaxed" data-testid="why-choose-us-subhead">
            {c.subtitle || (
              "We built this company on the little things — showing up on time, " +
              "explaining the work in plain English, and standing behind every job. " +
              "It's why our customers refer us, and why we keep growing without " +
              "ever running an ad."
            )}
          </p>
          <Link
            to="/about"
            data-testid="why-learn-more"
            className="mt-8 inline-flex items-center gap-2 text-[#2c2a29] font-bold hover:text-[#c85a3c] transition-colors"
          >
            More about our team
            <ArrowRight className="w-4 h-4" />
          </Link>
          <div className="mt-10 hidden lg:block rounded-3xl overflow-hidden aspect-[4/5] relative border border-[#e5e0d8] bg-gradient-to-br from-[#2c2a29] via-[#4a3d33] to-[#c85a3c]">
            {IMAGES.whyChooseUs && (
              <img
                src={IMAGES.whyChooseUs}
                alt="Our team at work"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-[#2c2a29]/50 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 text-[#fffdf9]">
              <div className="text-xs tracking-[0.24em] uppercase font-bold">
                Owner-operated since 2011
              </div>
              <div className="font-display text-2xl font-bold mt-2">
                Real people. Real accountability.
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {WHY_US.map((w) => {
            const Icon = ICONS[w.icon];
            return (
              <div
                key={w.title}
                data-testid={`why-${w.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-[#f9f6f0] rounded-2xl p-6 md:p-7 border border-[#e5e0d8] hover:border-[#c85a3c]/40 transition-colors"
              >
                <span className="w-11 h-11 rounded-xl bg-[#c85a3c]/10 text-[#c85a3c] flex items-center justify-center">
                  <Icon className="w-5 h-5" strokeWidth={2.4} />
                </span>
                <h3 className="mt-5 font-display text-lg md:text-xl font-bold text-[#2c2a29]">
                  {w.title}
                </h3>
                <p className="mt-2 text-sm text-[#5c5855] leading-relaxed">
                  {w.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
